export default {
  workspaceCode: '7GlPZkkKkbFCKaXy',
};
